import { NgModule } from "@angular/core";
import { ConnoteSitePickerDirective } from "./connote-site-picker.directive";

@NgModule({
  declarations: [ConnoteSitePickerDirective],
  exports     : [ConnoteSitePickerDirective]
})
export class ConnoteSitePickerModule { }
